import React from "react";
import { render } from "react-dom";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import initStore from "store/store";
import { ProviderWrapper } from "components/AppProvider/ProviderWrapper";
import { registerInterceptors } from "api/interceptors";
import { App } from "pages/App";

import * as serviceWorker from "./serviceWorker";
import "./index.scss";
import "./i18n";

const store = initStore();
registerInterceptors(store);

export const Root: React.FC = () => {
    return (
        <ProviderWrapper store={store}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <App />
            </MuiPickersUtilsProvider>
        </ProviderWrapper>
    );
};

render(<Root />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
